import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Input, Radio, Button, Modal, Skeleton, Empty, Avatar, Tooltip, Tag, Icon, Table, Menu, Dropdown } from 'antd';

import UsersModalForm from '~/components/Users/UsersModalForm';
import * as permissionsActions from '~/containers/Permissions/actions';
import * as usersActions from '~/components/Users/actions';
import { useImpersonate } from '~/context/Impersonate';

import {
    UserAvatarGroup, UsersHeader, PermissionCard, PermissionCardHeader, PermissionCardTitle,
    PermissionCardActions, ActionButton, UserCard, UserCardInfo, UserCardName, UserCardEmail,
    UserCardMeta, StatusBadge, PermissionBadge, UserGroupSection, UserGroupHeader, UserGroupTitle,
    UserGroupCount, ViewToggle, OrgChartContainer, OrgTreeWrapper, OrgTree, OrgRootCard,
    OrgConnector, OrgBranchContainer, OrgBranch, OrgGroupCard, OrgGroupTitle, OrgGroupCount,
    OrgUsersGrid, OrgUserCard, OrgUserInfo, OrgUserName, OrgUserEmail,
} from './styles';


var UsersContent = function(props) {
    var currentUser = props.user;
    var dispatch = useDispatch();
    var users = useSelector(function(state) { return state.users || []; });
    var permissionsGroups = useSelector(function(state) { return state.permissions.list || []; });
    var impersonateContext = useImpersonate();
    var impersonateUser = impersonateContext.impersonateUser;

    var modalState = useState({ isVisible: false, data: null });
    var modal = modalState[0];
    var setModal = modalState[1];
    var searchState = useState('');
    var search = searchState[0];
    var setSearch = searchState[1];
    var showActiveState = useState(true);
    var showActive = showActiveState[0];
    var setShowActive = showActiveState[1];
    var isLoadingState = useState(true);
    var isLoading = isLoadingState[0];
    var setIsLoading = isLoadingState[1];
    var viewModeState = useState('list');
    var viewMode = viewModeState[0];
    var setViewMode = viewModeState[1];

    useEffect(function() {
        Promise.all([
            dispatch(usersActions.loadUsers()),
            dispatch(permissionsActions.loadPermissionsGroups())
        ]).finally(function() {
            setIsLoading(false);
        });
    }, [dispatch]);

    var showModal = function(data) {
        setModal({ isVisible: true, data: data });
    };

    var hideModal = function() {
        setModal({ isVisible: false, data: null });
    };

    var getInitials = function(name) {
        if (!name) return '?';
        var parts = name.split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    var getAvatarColor = function(name) {
        var colors = ['#1890ff', '#52c41a', '#722ed1', '#fa8c16', '#eb2f96', '#13c2c2', '#2f54eb'];
        var hash = 0;
        for (var i = 0; i < (name || '').length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    var handleDisable = function(userId) {
        Modal.confirm({
            title: 'Desabilitar usuário',
            content: 'Você realmente deseja desabilitar este usuário? Você poderá reverter esta ação no futuro.',
            okText: 'Desabilitar',
            okType: 'warning',
            cancelText: 'Cancelar',
            onOk: function() {
                dispatch({
                    type: 'DISABLE_USER',
                    payload: {
                        request: {
                            method: 'patch',
                            url: '/user/' + userId + '/disable',
                        }
                    },
                    id: userId
                });
            },
        });
    };

    var handleActivate = function(userId) {
        dispatch({
            type: 'ACTIVE_USER',
            payload: {
                request: {
                    method: 'patch',
                    url: '/user/' + userId + '/active',
                }
            },
            id: userId
        });
    };

    var handleDelete = function(userId) {
        Modal.confirm({
            title: 'Excluir usuário',
            content: 'Você realmente deseja excluir este usuário? Esta ação não poderá ser desfeita.',
            okText: 'Excluir',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: function() {
                dispatch({
                    type: 'DELETE_USER',
                    payload: {
                        request: {
                            method: 'delete',
                            url: '/user/' + userId,
                        }
                    },
                    id: userId
                });
            },
        });
    };

    var filteredUsers = users.filter(function(u) {
        if (u.email === 'suporte@contlabs.com.br' || u.name === 'Suporte') return false;

        var matchesSearch = !search ||
            u.name.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
            u.email.toLowerCase().indexOf(search.toLowerCase()) > -1;

        if (!matchesSearch) return false;

        var isActiveStatus = u.status === 'Ativo' || u.status === 'Convidado';
        return showActive ? isActiveStatus : !isActiveStatus;
    });

    // Group users by permission group
    var groupedUsers = filteredUsers.reduce(function(groups, u) {
        var groupName = u.permissions_group_name || 'Personalizado';
        if (!groups[groupName]) {
            groups[groupName] = [];
        }
        groups[groupName].push(u);
        return groups;
    }, {});

    // Helper to get permission count for a group name
    var getPermissionCount = function(groupName) {
        var group = permissionsGroups.find(function(g) { return g.name === groupName; });
        return group && group.permissions ? group.permissions.length : 0;
    };

    // Sort group names by permission count (more permissions first), put Personalizado at the end
    var groupNames = Object.keys(groupedUsers).sort(function(a, b) {
        if (a === 'Personalizado') return 1;
        if (b === 'Personalizado') return -1;
        // Sort by number of permissions in group (descending)
        return getPermissionCount(b) - getPermissionCount(a);
    });

    var isOwner = currentUser && currentUser.tenant && currentUser.tenant.owner === currentUser.id;

    var renderUserCard = function(u) {
        var isCurrentUser = currentUser && currentUser.id === u.id;
        var isUserOwner = currentUser && currentUser.tenant && currentUser.tenant.owner === u.id;

        return (
            <UserCard key={u.id}>
                <Avatar size={40} style={{ backgroundColor: getAvatarColor(u.name), flexShrink: 0 }}>
                    {getInitials(u.name)}
                </Avatar>
                <UserCardInfo>
                    <UserCardName>
                        {isCurrentUser ? <strong>{u.name}</strong> : u.name}
                        {isUserOwner && (
                            <Tag color="blue" style={{ marginLeft: 4 }}>Proprietário</Tag>
                        )}
                    </UserCardName>
                    <UserCardEmail>{u.email}</UserCardEmail>
                </UserCardInfo>
                <UserCardMeta>
                    <StatusBadge status={u.status}>{u.status}</StatusBadge>
                </UserCardMeta>
                {!isCurrentUser && (
                    <PermissionCardActions>
                        <Tooltip title="Editar permissões">
                            <ActionButton onClick={function() { showModal(u); }}>
                                <Icon type="edit" />
                            </ActionButton>
                        </Tooltip>
                        {u.status !== 'Desativado' ? (
                            <Tooltip title="Desabilitar">
                                <ActionButton onClick={function() { handleDisable(u.id); }}>
                                    <Icon type="stop" />
                                </ActionButton>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Ativar">
                                <ActionButton onClick={function() { handleActivate(u.id); }}>
                                    <Icon type="check" />
                                </ActionButton>
                            </Tooltip>
                        )}
                        <Tooltip title="Personificar usuário">
                            <ActionButton onClick={function() { impersonateUser(u.id); }}>
                                <Icon type="login" />
                            </ActionButton>
                        </Tooltip>
                        <Tooltip title="Excluir">
                            <ActionButton className="danger" onClick={function() { handleDelete(u.id); }}>
                                <Icon type="delete" />
                            </ActionButton>
                        </Tooltip>
                    </PermissionCardActions>
                )}
            </UserCard>
        );
    };

    return (
        <div>
            <UsersHeader>
                <Input.Search
                    placeholder="Pesquisar usuários"
                    onChange={function(e) { setSearch(e.target.value); }}
                    style={{ width: 250 }}
                    allowClear
                />
                <Radio.Group
                    value={showActive}
                    onChange={function(e) { setShowActive(e.target.value); }}
                >
                    <Radio.Button
                        value={true}
                        style={showActive ? { borderColor: '#52c41a', color: '#52c41a' } : undefined}
                    >
                        Ativos
                    </Radio.Button>
                    <Radio.Button
                        value={false}
                        style={!showActive ? { borderColor: '#ff4d4f', color: '#ff4d4f', boxShadow: '-1px 0 0 0 #ff4d4f' } : undefined}
                    >
                        Inativos
                    </Radio.Button>
                </Radio.Group>
                <ViewToggle>
                    <Tooltip title="Visualização em lista">
                        <button
                            className={viewMode === 'list' ? 'active' : ''}
                            onClick={function() { setViewMode('list'); }}
                        >
                            <Icon type="unordered-list" />
                        </button>
                    </Tooltip>
                    <Tooltip title="Visualização em tabela">
                        <button
                            className={viewMode === 'table' ? 'active' : ''}
                            onClick={function() { setViewMode('table'); }}
                        >
                            <Icon type="table" />
                        </button>
                    </Tooltip>
                    <Tooltip title="Organograma">
                        <button
                            className={viewMode === 'org' ? 'active' : ''}
                            onClick={function() { setViewMode('org'); }}
                        >
                            <Icon type="apartment" />
                        </button>
                    </Tooltip>
                </ViewToggle>
                <div style={{ flex: 1 }} />
                <Button type="primary" onClick={function() { showModal(); }}>
                    <Icon type="plus" /> Convidar Usuário
                </Button>
            </UsersHeader>

            {isLoading ? (
                viewMode === 'list' ? (
                    <div>
                        {[1, 2, 3, 4].map(function(i) {
                            return (
                                <UserCard key={i}>
                                    <Skeleton avatar={{ size: 40 }} active paragraph={{ rows: 0 }} />
                                </UserCard>
                            );
                        })}
                    </div>
                ) : viewMode === 'table' ? (
                    <div className="table-clabs">
                        <Skeleton active paragraph={{ rows: 5 }} />
                    </div>
                ) : (
                    <OrgChartContainer>
                        <div style={{ textAlign: 'center' }}>
                            <Skeleton.Button active style={{ width: 150, height: 60, borderRadius: 12 }} />
                            <div style={{ display: 'flex', justifyContent: 'center', gap: 40, marginTop: 40 }}>
                                {[1, 2, 3].map(function(i) {
                                    return (
                                        <div key={i} style={{ textAlign: 'center' }}>
                                            <Skeleton.Button active style={{ width: 120, height: 70, borderRadius: 10 }} />
                                            <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
                                                {[1, 2].map(function(j) {
                                                    return (
                                                        <Skeleton.Button key={j} active style={{ width: 140, height: 50, borderRadius: 8 }} />
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </OrgChartContainer>
                )
            ) : filteredUsers.length === 0 ? (
                <Empty
                    description={search ? "Nenhum usuário encontrado" : (showActive ? "Nenhum usuário ativo" : "Nenhum usuário inativo")}
                    style={{ padding: 40 }}
                />
            ) : viewMode === 'list' ? (
                groupNames.map(function(groupName) {
                    var usersInGroup = groupedUsers[groupName];
                    var isCustomGroup = groupName === 'Personalizado';
                    var permCount = getPermissionCount(groupName);

                    return (
                        <UserGroupSection key={groupName}>
                            <UserGroupHeader>
                                <Icon
                                    type={isCustomGroup ? 'setting' : 'team'}
                                    style={{ color: isCustomGroup ? '#fa8c16' : '#722ed1' }}
                                />
                                <UserGroupTitle>
                                    {groupName}
                                    {!isCustomGroup && (
                                        <span style={{ color: '#8c8c8c', fontWeight: 400, fontSize: 12, marginLeft: 6 }}>
                                            ({permCount} {permCount === 1 ? 'permissão' : 'permissões'})
                                        </span>
                                    )}
                                </UserGroupTitle>
                                <UserGroupCount>{usersInGroup.length} {usersInGroup.length === 1 ? 'usuário' : 'usuários'}</UserGroupCount>
                            </UserGroupHeader>
                            {usersInGroup.map(renderUserCard)}
                        </UserGroupSection>
                    );
                })
            ) : viewMode === 'table' ? (
                <div className="table-clabs">
                    <Table
                        rowKey="id"
                        dataSource={filteredUsers}
                        pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '50'] }}
                        size="middle"
                    >
                        <Table.Column
                            title="Usuário"
                            key="user"
                            render={function(text, record) {
                                var isCurrentUser = currentUser && currentUser.id === record.id;
                                var isUserOwner = currentUser && currentUser.tenant && currentUser.tenant.owner === record.id;
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        <Avatar size={32} style={{ backgroundColor: getAvatarColor(record.name), flexShrink: 0 }}>
                                            {getInitials(record.name)}
                                        </Avatar>
                                        <div>
                                            <div style={{ fontWeight: isCurrentUser ? 600 : 400 }}>
                                                {record.name}
                                                {isUserOwner && <Tag color="blue" style={{ marginLeft: 8 }}>Proprietário</Tag>}
                                            </div>
                                            <div style={{ fontSize: 12, color: '#8c8c8c' }}>{record.email}</div>
                                        </div>
                                    </div>
                                );
                            }}
                        />
                        <Table.Column
                            title="Permissões"
                            key="permissions"
                            render={function(text, record) {
                                if (record.permissions_group_name) {
                                    var permCount = getPermissionCount(record.permissions_group_name);
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Tag color="purple">{record.permissions_group_name}</Tag>
                                            <span style={{ color: '#8c8c8c', fontSize: 12 }}>{permCount}</span>
                                        </div>
                                    );
                                }
                                return <Tag color="orange">Personalizado</Tag>;
                            }}
                        />
                        <Table.Column
                            title="Status"
                            dataIndex="status"
                            key="status"
                            render={function(status) {
                                var color = status === 'Ativo' ? 'green' : status === 'Convidado' ? 'purple' : 'red';
                                return <Tag color={color}>{status}</Tag>;
                            }}
                        />
                        <Table.Column
                            title=""
                            key="actions"
                            width={100}
                            render={function(text, record) {
                                var isCurrentUser = currentUser && currentUser.id === record.id;
                                if (isCurrentUser) return null;

                                var menuItems = (
                                    <Menu onClick={function(e) {
                                        if (e.key === 'edit') showModal(record);
                                        else if (e.key === 'disable') handleDisable(record.id);
                                        else if (e.key === 'activate') handleActivate(record.id);
                                        else if (e.key === 'impersonate') impersonateUser(record.id);
                                        else if (e.key === 'delete') handleDelete(record.id);
                                    }}>
                                        <Menu.Item key="edit">
                                            <Icon type="edit" /> Permissões
                                        </Menu.Item>
                                        {record.status !== 'Desativado' ? (
                                            <Menu.Item key="disable">
                                                <Icon type="stop" /> Desabilitar
                                            </Menu.Item>
                                        ) : (
                                            <Menu.Item key="activate">
                                                <Icon type="check" /> Ativar
                                            </Menu.Item>
                                        )}
                                        <Menu.Item key="impersonate">
                                            <Icon type="login" /> Personificar
                                        </Menu.Item>
                                        <Menu.Divider />
                                        <Menu.Item key="delete" style={{ color: '#ff4d4f' }}>
                                            <Icon type="delete" /> Excluir
                                        </Menu.Item>
                                    </Menu>
                                );

                                return (
                                    <Dropdown overlay={menuItems} trigger={['click']}>
                                        <a onClick={function(e) { e.preventDefault(); }}>
                                            Ações <Icon type="down" />
                                        </a>
                                    </Dropdown>
                                );
                            }}
                        />
                    </Table>
                </div>
            ) : (
                <OrgChartContainer>
                    <OrgTreeWrapper>
                    <OrgTree>
                        <OrgRootCard>
                            <div className="title">
                                <Icon type="team" style={{ marginRight: 8 }} />
                                Equipe
                            </div>
                            <div className="subtitle">{filteredUsers.length} usuários</div>
                        </OrgRootCard>
                        <OrgConnector />
                        <OrgBranchContainer>
                            {groupNames.map(function(groupName) {
                                var usersInGroup = groupedUsers[groupName];
                                var isCustomGroup = groupName === 'Personalizado';
                                var permCount = getPermissionCount(groupName);

                                return (
                                    <OrgBranch key={groupName}>
                                        <OrgGroupCard isCustom={isCustomGroup}>
                                            <Icon type={isCustomGroup ? 'setting' : 'folder'} />
                                            <OrgGroupTitle>{groupName}</OrgGroupTitle>
                                            {!isCustomGroup && (
                                                <OrgGroupCount>{permCount} {permCount === 1 ? 'permissão' : 'permissões'}</OrgGroupCount>
                                            )}
                                            <OrgGroupCount style={{ marginTop: isCustomGroup ? 0 : 2 }}>{usersInGroup.length} {usersInGroup.length === 1 ? 'usuário' : 'usuários'}</OrgGroupCount>
                                        </OrgGroupCard>
                                        <OrgUsersGrid>
                                            {usersInGroup.map(function(u) {
                                                var isCurrentUser = currentUser && currentUser.id === u.id;
                                                var statusColor = u.status === 'Ativo' ? '#52c41a' : u.status === 'Convidado' ? '#722ed1' : '#ff4d4f';

                                                return (
                                                    <Tooltip
                                                        key={u.id}
                                                        title={
                                                            <div>
                                                                <div style={{ fontWeight: 500 }}>{u.name}</div>
                                                                <div style={{ fontSize: 11, opacity: 0.8 }}>{u.email}</div>
                                                                <div style={{ fontSize: 11, marginTop: 4 }}>
                                                                    Status: <span style={{ color: statusColor }}>{u.status}</span>
                                                                </div>
                                                            </div>
                                                        }
                                                        placement="bottom"
                                                    >
                                                        <OrgUserCard onClick={function() { if (!isCurrentUser) showModal(u); }}>
                                                            <Avatar size={24} style={{ backgroundColor: getAvatarColor(u.name), flexShrink: 0, fontSize: 10 }}>
                                                                {getInitials(u.name)}
                                                            </Avatar>
                                                            <OrgUserInfo>
                                                                <OrgUserName style={{ fontWeight: isCurrentUser ? 600 : 500 }}>
                                                                    {u.name}
                                                                </OrgUserName>
                                                            </OrgUserInfo>
                                                            <div style={{ width: 6, height: 6, borderRadius: '50%', background: statusColor, flexShrink: 0 }} />
                                                        </OrgUserCard>
                                                    </Tooltip>
                                                );
                                            })}
                                        </OrgUsersGrid>
                                    </OrgBranch>
                                );
                            })}
                        </OrgBranchContainer>
                    </OrgTree>
                    </OrgTreeWrapper>
                </OrgChartContainer>
            )}

            <UsersModalForm
                visible={modal.isVisible}
                onCancel={hideModal}
                data={modal.data}
            />
        </div>
    );
};

export default UsersContent;
